class Timeline {

	static instances = [];

	constructor( node, opts = {} ) {

		if ( ! node ) {
			return;
		}

		this.node = node;
		this.opts = {
			classes: {
				hideButton: 'timeline--hide-button',
				open: 'timeline--open',
				opened: 'timeline--opened',
				fixMedia: 'timeline--fix-media',
				nextElement: '.timeline__after',
				previousElement: '.timeline__before',
				container: '.timeline-items__inner',
				covers: '.timeline-cover',
				cover: 'timeline-cover',
				toggle: '.timeline__expand-and-explore button',
				coverInView: 'timeline-cover--in-view',
				nav: '.timeline__nav',
				navItem: 'timeline__nav-item',
				navItemActive: 'timeline__nav-item--active',
				anchor: '.anchor',
				usingExpand: 'timeline--use-expand-and-explore',
				masthead: 'masthead',
				footer: 'footer',
			},
		}

		this.opened = false;
		this.buffer = 5;
		this.usingExpand = this.node.classList.contains(this.opts.classes.usingExpand);
		this.container = this.node.querySelector(this.opts.classes.container);
		this.covers = this.node.querySelectorAll(this.opts.classes.covers) ?? [];
		this.toggle = this.node.querySelector(this.opts.classes.toggle);
		this.nextElement = this.node.querySelector(this.opts.classes.nextElement);
		this.previousElement = this.node.querySelector(this.opts.classes.previousElement);
		this.masthead = document.getElementById(this.opts.classes.masthead);
		this.footer = document.getElementById(this.opts.classes.footer);
		this.anchors = this.node.querySelectorAll(this.opts.classes.anchor);
		this.nav = {
			item: this.node.querySelector(this.opts.classes.navItem),
			container: this.node.querySelector(this.opts.classes.nav),
			items: []
		};

		[...this.anchors].forEach((anchor, i) => {
			const el = document.createElement('button');
			el.classList.add(this.opts.classes.navItem);
			el.innerText = anchor.dataset.anchorText ?? anchor.id;
			el.dataset.href = anchor.id
			if (i === 0) {
				el.classList.add(this.opts.classes.navItemActive);
			}

			el.addEventListener('click', (event) => {
				const panel = this.node.querySelector('#' + event.target.dataset.href);
				panel.scrollIntoView({
					behavior: 'smooth',
					block: 'center'
				});
				[...this.nav.container.children].forEach((a) => {
					a.classList.remove(this.opts.classes.navItemActive);
				});


				event.target.classList.add(this.opts.classes.navItemActive);
			});
			this.nav.container.appendChild(el);
		});

		this.nav.items = [ ...this.nav.container.children];



		this.observers = {
			childInView: new IntersectionObserver(
				(entries) => this.childInView(entries),
				{
					threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.81, 0.85, 0.9, 0.95, 0.96, 0.97, 0.98, 0.99, 1]
				}
			),
			neighbor: new IntersectionObserver(
				(entries) => this.close(entries),
				{
					threshold: 1,
				}
			),
			node: new IntersectionObserver(
				(entries) => this.nodeInView(entries),
				{
					threshold: 0.05,
				}
			),
		}

		this.toggle.addEventListener( 'click', (e) => {
			this.init();
		} );


		this.observers.neighbor.observe(this.nextElement);
		this.observers.neighbor.observe(this.previousElement);
		this.observers.neighbor.observe(this.masthead);
		this.observers.neighbor.observe(this.footer);
		this.observers.node.observe(this.node);
	}

	nodeInView(entries) {
		entries.forEach((entry) => {
			if ( entry.isIntersecting ) {

				this.interval = setInterval(() => {
					const distanceFromTopOfViewport = this.node.getBoundingClientRect().y;
					if (distanceFromTopOfViewport < this.buffer) {
						if (!this.opened && !this.usingExpand) {
							this.init();
						}
						clearInterval(this.interval);

					}
				}, 33);

			} else {
				this.close();
			}
		});
	}

	getIndexOfCover(target) {
		return [...this.covers].indexOf(target) ?? 0;
	}

	getIndexOfItem(target) {
		return [...this.container.children].indexOf(target) ?? 0;
	}

	init() {
		this.opened = true;
		if ( this.usingExpand ) {
			this.node.scrollIntoView({
				behavior: 'smooth',
			});
		}

		this.node.classList.add(this.opts.classes.hideButton);
		this.node.classList.add(this.opts.classes.opened);
		this.node.classList.add(this.opts.classes.open);
		this.node.classList.add(this.opts.classes.fixMedia);
		[ ...this.container.children].forEach((cover) => {
			this.observers.childInView.observe(cover);
		});

		this.activateCover();
	}

	childInView(entries) {

		entries.forEach((entry) => {
			if ( entry.isIntersecting ) {
				const isLastPanel = this.getIndexOfItem(entry.target) === this.container.children.length - 1;
				const isFirstPanel = this.getIndexOfItem(entry.target) === 0;
				const isCover = entry.target.classList.contains(this.opts.classes.cover);


				if ( entry.intersectionRatio > 0.4 )  {

					if (isCover) {
						this.activateCover(entry.target);
						this.adjustIndicator(entry.target);
						return;
					}

					if (!isFirstPanel && !isLastPanel) {
						this.opened = true;
						this.node.classList.add(this.opts.classes.fixMedia);
					}
				}
			}
		});
	}

	activateCover(target) {
		if (!target) {
			target = this.covers[0];
		}
		this.deactivateCovers();
		target.classList.add(this.opts.classes.coverInView);
	}

	deactivateCover(target) {
		target.classList.remove(this.opts.classes.coverInView);
	}

	deactivateCovers() {
		this.covers.forEach((item) => {
			this.deactivateCover(item);
		});
	}

	adjustIndicator( target ) {

		const anchor = target.querySelector(this.opts.classes.anchor);
		if (! anchor) {
			return;
		}

		const navItem = this.nav.container.querySelector(`[data-href="${anchor.id}"]`);

		this.nav.items.forEach((item) => {
			item.classList.remove(this.opts.classes.navItemActive);
		});

		navItem.classList.add(this.opts.classes.navItemActive);
	}

	close(entries) {
		if (!entries) {
			this.deactivateCovers();
			this.node.classList.remove(this.opts.classes.fixMedia);
			this.opened = false;
			return;
		}
		entries.forEach((entry) => {
			if ( entry.isIntersecting ) {
				this.deactivateCovers();
				this.node.classList.remove(this.opts.classes.fixMedia);
				this.opened = false;
			}
		});
	}
}

const timelines = document.querySelectorAll( '.timeline' );
export const instances = [ ...timelines ].map( node => new Timeline( node ) );
